import { addDays, isoWeekday, monthStart, nextMonth } from '@squadcore/api/shared/time'

// Used by the route loader outside the lazy page chunk, so this module stays free of components.

export type CalendarSearch = { view?: 'week' | 'list'; date?: string; hide?: string }

/** Visible days: whole weeks around the month (Monday start), the week, or the month for the list. */
export function calendarRange(view: 'month' | 'week' | 'list', date: string) {
  if (view === 'week') {
    const from = addDays(date, 1 - isoWeekday(date))
    return { from, to: addDays(from, 6) }
  }
  const first = monthStart(date)
  const last = addDays(nextMonth(date), -1)
  if (view === 'list') return { from: first, to: last }
  return { from: addDays(first, 1 - isoWeekday(first)), to: addDays(last, 7 - isoWeekday(last)) }
}
